/**
 * @file コンポーネント：協賛企業リスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledPartnerlist,
    StyledPartnerlistAnchor,
    StyledPartnerlistImage,
    StyledPartnerlistItem,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledPartnerlist>
            {props.list.map((item, index) => (
                <StyledPartnerlistItem key={"partner-" + index}>
                    <StyledPartnerlistAnchor href={item.url} target="_blank">
                        <StyledPartnerlistImage
                            alt={item.name}
                            height="82"
                            src={item.imgSrc}
                            width="164"
                        />
                    </StyledPartnerlistAnchor>
                </StyledPartnerlistItem>
            ))}
        </StyledPartnerlist>
    );
};
